/* global axios */
import ApiClient from '../ApiClient';

class BrainKnowledgeAPI extends ApiClient {
  constructor() {
    super('brain/knowledge', { accountScoped: true });
  }

  get({ page = 1, search, assistantId, status, type } = {}) {
    return axios.get(this.url, {
      params: { page, q: search, assistant_id: assistantId, status, type },
    });
  }

  create(data) {
    const { assistantId, ...knowledgeData } = data;
    return axios.post(
      this.url,
      { knowledge: knowledgeData },
      { params: { assistant_id: assistantId } }
    );
  }

  // storeFactory calls update(id, updateObj) with 2 args (id separate from data)
  update(id, updateObj = {}) {
    const { assistantId, ...knowledgeData } = updateObj;
    return axios.patch(
      `${this.url}/${id}`,
      { knowledge: knowledgeData },
      { params: { assistant_id: assistantId } }
    );
  }

  delete(payload) {
    const { id, assistantId } =
      typeof payload === 'object' ? payload : { id: payload };
    return axios.delete(`${this.url}/${id}`, {
      params: { assistant_id: assistantId },
    });
  }

  activate({ id, assistantId }) {
    return axios.patch(
      `${this.url}/${id}/activate`,
      {},
      { params: { assistant_id: assistantId } }
    );
  }

  archive({ id, assistantId }) {
    return axios.patch(
      `${this.url}/${id}/archive`,
      {},
      { params: { assistant_id: assistantId } }
    );
  }

  bulkActions({ ids, action, assistantId }) {
    return axios.post(
      `${this.url}/bulk_actions`,
      { ids, action },
      { params: { assistant_id: assistantId } }
    );
  }
}

export default new BrainKnowledgeAPI();
